import React from "react";
import PropTypes from "prop-types";
import { shortDateAndTimestamp } from "LIB/formatters/date";
import { CONTACT_NAME, CREATED_AT, CREATED_BY } from "APP_ROOT/constants";
import { FULL_NAME } from "MODULES/users/constants";

export default function ExistingQuoteWarning({ quote }) {
  return (
    <div className="center-block alert alert-info">
      <div className="media">
        <div className="media-left">
          <i className="fa fa-lg fa-warning text-info" />
        </div>
        <div className="media-body">
          The part number has already been quoted to {quote.get("company_name")}{" "}
          within the last 36 hours. It was quoted by{" "}
          {quote.getIn([CREATED_BY, FULL_NAME])} to {quote.get(CONTACT_NAME)} on{" "}
          {shortDateAndTimestamp(quote.get(CREATED_AT))}. If you think it might
          be for the same order, please transfer to{" "}
          {quote.getIn([CREATED_BY, FULL_NAME])}.
        </div>
      </div>
    </div>
  );
}

ExistingQuoteWarning.propTypes = {
  quote: PropTypes.shape({
    company: PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.number
    })
  })
};



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/shared/ExistingQuoteWarning.jsx